<template>
    <modal @close="close" dialog="modal-lg" class="reservation-modal view dark-top">
        <div slot="title">
            <view-header title="Reservation details"></view-header>
        </div>

        <div slot="body">
            <tabs>
                <tab name="Overview">
                    <overview></overview>
                    <stats></stats>
                </tab>
                <tab name="Reservation details">
                    <more></more>
                </tab>
                <!-- <tab name="Proforma">
                    <invoices></invoices>
                </tab>
                <tab name="History">
                    <history></history>
                </tab> -->
            </tabs>
        </div>

        <div slot="footer">
            <div v-if="getClonedReservation.status !== -5" class="relative mr-auto" v-click-outside="closeActions">
                <button class="btn tertiary m-0 wider" @click="toggleActions">Actions</button>

                <ul class="floating-menu top wide" v-if="showActions">
                    <li>Send by email</li>
                    <li>Print</li>
                    <li @click="reschedule">Reschedule</li>
                    <li @click="cancel">Cancel reservation</li>
                </ul>
            </div>

            <div v-if="getClonedReservation.status !== -5">
                <button type="button" class="btn blue wider" @click="goToPayment">Pay</button>
                <button type="button" class="btn ok wider" @click="save" :disabled="getIsUpdatingReservation" >Save</button>
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Modal from './Modal'
    import Stats from '@/components/reservations/view/ViewStatistics'
    import ViewHeader from '@/components/reservations/view/ViewHeader'
    import Overview from '@/components/reservations/view/ViewOverview'
    import More from '@/components/reservations/view/ViewMore'
    import Invoices from '@/components/reservations/view/ViewInvoices'
    import History from '@/components/reservations/view/ViewHistory'

    export default {
        props: {
            show: {
                type: Boolean,
                default: false,
            }
        },
        data: function() {
            return {
                showActions: false,
            }
        },
        created: function() {
            if (this.getSelectedReservation) {
                this.updateClonedReservation(JSON.parse(JSON.stringify(this.getSelectedReservation)));
            }
        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
                'getSelectedReservation',
                'account',
                'getIsUpdatingReservation'
            ]),
        },
        methods: {
            ...mapActions([
                'resetNewReservationSetup',
                'updateClonedReservation',
                'clearActiveReservation',
                'updateReservation',
                'openModal',
                'closeModal',
            ]),
            goToPayment: function() {
                this.openModal('ReservationPayment');
            },
            cancel: function() {
                this.openModal('ReservationCancel');
            },
            reschedule: function() {
                this.resetNewReservationSetup().then(() => {
                    this.openModal('ReservationAdd');
                });
            },
            save: function() {
                this.updateReservation({
                    action: 'edit',
                    fields: { supplierId: this.account.supplierId, reservation: this.getClonedReservation }
                });

                this.close();
            },
            close: function() {
                this.showActions = false;
                this.clearActiveReservation();
                this.closeModal();
            },
            toggleActions: function() {
                this.showActions = !this.showActions;
            },
            closeActions: function() {
                this.showActions = false;
            },
        },
        components: {
            Modal,
            ViewHeader,
            Overview,
            More,
            Invoices,
            History,
            Stats,
        }
    }
</script>

<style lang="scss" scoped>
    .floating-menu {
        width: 200%;
    }
</style>



// WEBPACK FOOTER //
// ReservationView.vue?546d12ce